export const SiteLinks = [
  {
    name: "Deviantart",
    link: "https://www.deviantart.com/azizstark/",
  },
  {
    name: "Github",
    link: "https://github.com/AzizStark",
  },
  {
    name: "Portfolio",
    link: "https://azizstark.com/",
  },
  {
    name: "Dribbble",
    link: "https://dribbble.com/AzizStark",
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/theazizrahman/",
  },
  {
    name: "Instagram",
    link: "https://www.instagram.com/the_pixel_dreamer/",
  },
];
